<div class="fancy-slice"></div>
